<template>
  <div id="tablePicture" class="TableListItem tablePicture" v-if="!is_null">
    <div class="tablePictureOne">
      <p class="leftName">外观</p>
      <div class="rightBox">
        <template v-for="i in 5" :key="i">
          <img
            class="iconImgBox"
            :src="shanhe_apperance_img(i)"
            v-if="i <= shanhe.apperance"
          />
          <!-- <img class="iconImgBox" src="" alt="" v-else> -->
        </template>
      </div>
    </div>
    <div class="tablePictureTwo">
      <p class="leftName">基础信息</p>
      <div class="rightBox">
        <div class="nameBox">
          灵宝总评：<span>{{ base['score'] }}</span>
        </div>
        <div class="nameBox">
          等级：<span>{{ base['level'] }}</span>
        </div>
      </div>
    </div>
    <div class="tablePictureThree">
      <div class="leftName">洗练</div>
      <div class="rightBox">
        <div class="nameBox">
          最大物理攻击：<span>{{ xilian['pmax'] }}</span>
        </div>
        <div class="nameBox">
          最小物理攻击：<span>{{ xilian['pmin'] }}</span>
        </div>
        <div class="nameBox">
          最大法术攻击：<span>{{ xilian['mmax'] }}</span>
        </div>
        <div class="nameBox">
          最小法术攻击：<span>{{ xilian['mmin'] }}</span>
        </div>

        <template v-if="xilian['avoid']">
          <div class="nameBox">
            回避：<span>{{ xilian['avoid'] }}</span>
          </div>
          <div class="nameBox">
            神明：<span>{{ xilian['skprt'] }}</span>
          </div>
        </template>
        <template v-else>
          <div class="nameBox">
            命中：<span>{{ xilian['hit'] }}</span>
          </div>
          <div class="nameBox">
            会心：<span>{{ xilian['cri'] }}</span>
          </div>
        </template>
      </div>
    </div>
    <div class="tablePictureFour">
      <div class="leftName">强化</div>
      <div class="FourBox">
        <div class="nameBox">
          强化等级：<span>{{ strengthen['level'] }}</span>
        </div>
        <div class="nameBox TwoFourBox">
          提炼洗练属性：<span class="color"
            ><i>{{ strengthen['normal_score'] }}%</i> +
            <i style="color: #0f0">{{ strengthen['extra_score'] }}%</i></span
          >
        </div>
        <div style="padding-left: 30px">等级对应：</div>
        <div class="rightBox">
          <div
            class="nameBox"
            v-for="(val, v_index) in strengthen['rate_list']"
            :key="v_index"
          >
            {{ v_index + 1 }}级：<span>{{ val }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="tablePictureFive">
      <div class="leftName">灵曜</div>
      <div class="FourBox">
        <div class="nameBox">
          灵曜等级：<span>{{ lingyao['level'] }}</span>
        </div>
        <div class="threeFourBox">
          附加属性：
          <span class="spanChange">
            <p v-if="lingyao['extra_attr'] == '<p></p>'">
              <span class="kong"></span>
            </p>
            <div v-else v-html="lingyao['extra_attr']"></div>
          </span>
        </div>
      </div>
      <div class="rightBoxHovers">
        灵曜道具：
        <commonItem
          :content="prop['content']"
          v-for="(prop, o_index) in lingyao['prop']"
          :key="o_index"
          :src="shanhe_lingyao_img(prop['icon'])"
          :class="`equip_pic equip_pic${o_index}`"
        >
          <template v-slot:title>
            <span
              class="tooltip_title tooltip_title_color"
              :style="{ color: `yellow` }"
            >
              {{ prop['name'] }}
            </span>
          </template>
        </commonItem>
        <!-- {% for prop in lingyao['prop'] %}
        <div
          class="equip_pic equip_pic{{ loop.index+1 }}"
          title_name="#Y{{ prop['name'] }}"
          intro="{{ prop['content'] }}"
        >
          <img src="{{ prop['icon']|shanhe_lingyao_img }}" />
          <a
            class="elvl elvl_4"
            href="javascript:void(0);"
            style="border: 1px solid #bb44bb"
          >
          </a>
        </div>
        {% endfor %} -->
      </div>
    </div>
  </div>
  <div id="tableCHILD" class="TableListItem" v-else>
    <div class="none-tips">该角色暂无山河画卷相关属性</div>
  </div>
</template>

<script setup>
import { defineProps, ref, computed, inject } from 'vue';

const { shanhe_apperance_img, shanhe_lingyao_img } = inject('filters');

const props = defineProps({
  role_data: {
    type: Object,
    default: () => ({}),
  },
});

const shanhe = computed(() => {
  return props.role_data?.shanhe || {};
});

const xilian = computed(() => {
  return shanhe.value.xilian || {};
});

const base = computed(() => {
  return shanhe.value.base || {};
});

const lingyao = computed(() => {
  return shanhe.value.lingyao || {};
});

const strengthen = computed(() => {
  return shanhe.value.strengthen || {};
});

const is_null = computed(() => {
  return Object.keys(shanhe.value || {}).length == 0;
});
</script>
